export class LoginModel {
    public identifier: string;
    public password: string;
    public flushCode: string;
}

export class SendNotificationModel {
    public identifier: string;
    public contactVerify: string;
    public mediaTarget: TwoFactorAuthentication = TwoFactorAuthentication.EMAIL;
    public notificationType: AuthMode = AuthMode.OTP;
}

export class OtpNotificationModel {
    contactVerify: string;
    NotificationTarget : TwoFactorAuthentication = TwoFactorAuthentication.EMAIL;
    UserIdentifier : string;
}

export class OtpModel {
    public userCode: string;
    public otp: string;
}

export class AccountPasswordModel {
    public identifier: string;
    public newPassword: string;
    public confirmPassword: string;
    public authorizationCode: string;
    public userType: string;
    public isRawToken : boolean;
}

export enum TwoFactorAuthentication {
    EMAIL = 'EMAIL',
    PHONE = 'PHONE'
}

export enum AuthMode {
    GEN = 'GEN',
    OTP = 'OTP'
}